<template>
    <v-layout row style="margin: 18px;">
        <v-flex xs6 ma-2>
            <v-card>
                <v-card-title class="headline grey lighten-3" primary-title>
                    <v-flex v-if="!Update_Details">
                        <v-icon style="padding-right: 24px;">note_add</v-icon>Add User
                    </v-flex>
                    <v-flex v-else>Update User</v-flex>
                </v-card-title>
                <v-card-text style="padding: 55px 30px;padding-bottom: 0px;">
                    <v-flex>
                        <v-text-field label="User Name" v-model="Username"></v-text-field>
                        <v-text-field label="Email" v-model="Email"></v-text-field>
                        <v-select v-model="SelectedTabs" :items="AccessTabs" label="Select Tabs" multiple></v-select>
                    </v-flex>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                    <v-btn color="primary" v-if="!Update_Details" @click="AddUser">Add User</v-btn>
                    <v-btn color="primary" v-else @click="UpdateUser">Update User</v-btn>
                    <v-btn color="primary" flat @click="ClearForm">Clear</v-btn>
                </v-card-actions>
            </v-card>
        </v-flex>

        <v-flex xs6 ma-2>
            <v-data-table :headers="headers"  hide-actions :items="Users" height="inherit" class="elevation-1">
                <template v-slot:headers="props">
                    <tr>
                        <th v-for="header in props.headers" :key="header.text">{{ header.text }} </th>
                    </tr>
                </template>
                <template v-slot:items="props">
                <tr>
                    <td class="text-xs-center">{{ props.item.User_Name }}</td>
                    <td class="text-xs-center">{{ props.item.Email }}</td>
                    <td class="text-xs-center">
                        <v-btn color="primary" icon class="btnAction" @click="EditUser(props.item)">
                            <v-icon>edit</v-icon>
                        </v-btn>
                        <v-btn color="error" icon v-if="props.item.User_Type == 'User'" class="btnAction" @click="DeleteUser(props.item)">
                            <v-icon>delete</v-icon>
                        </v-btn>
<!-- <v-btn color="error" icon class="btnAction" @click="DeleteUser(props.item)">
                <v-icon>delete</v-icon>
              </v-btn> -->
                    </td>
                </tr>
                </template>
            </v-data-table>
        </v-flex>

    </v-layout>
</template>
<script>
export default {
    data(){
        return {
            Update_Details : false,
            Username       : '',
            Email          : '',
            SelectedTabs   : [],
            AccessTabs     : [],
            Users          : [],
            headers        : [ { text: "User Name", value: "User_Name" },
                               { text: 'Email' ,value:'Email' },
                               { text: "Actions" }
                             ],
            User_Id        : '',

        }
    },
    methods:{
        AddUser(){
            let data = { 

                User_Name   : this.Username,
                Email       : this.Email.toLowerCase(), 
                User_Type   : 'User',
                Access_Tabs : this.SelectedTabs
            }
            this.$http.post(`${this.$store.getters.GetProductionUrl}/register/adduser`,data)
                        .then(response =>{
                            
                            if(response['data']['Status']){

                                this.Users      = response['data']['response']
                                this.AccessTabs = response['data']['All_Tabs']
                                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Added User","Color":"green","Close": false });
                                this.$eventHub.$emit("LOADING",'false')
                                this.ClearForm()

                            }else{
                                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Couldn't Add User","Color":"red","Close": false });
                            }
                            
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                            this.$eventHub.$emit("LOADING",'false')
                        })
            
        },
        EditUser(Item){
            this.User_Id        = Item['_id']
            this.Username       = Item['User_Name']
            this.Email          = Item['Email'].toLowerCase()
            this.SelectedTabs   = Item['Access_Tabs']
            this.Update_Details = true
        },
        UpdateUser(){

            let data = { }
            data['User_Id'] = this.User_Id
            data['Update'] = {

                User_Name   : this.Username,
                Email       : this.Email.toLowerCase(),
                Access_Tabs : this.SelectedTabs

            }
            this.$http.post(`${this.$store.getters.GetProductionUrl}/register/updateuser`,data)
                        .then(response =>{
                            
                            if(response['data']['Status']){

                                this.Users      = response['data']['response']
                                this.AccessTabs = response['data']['All_Tabs']
                                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Update User","Color":"green","Close": false });
                                this.$eventHub.$emit("LOADING",'false')  
                                this.ClearForm()

                            }else{
                                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Couldn't Update User","Color":"red","Close": false });
                            }

                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                            this.$eventHub.$emit("LOADING",'false')
                        })
        },
        DeleteUser(item){
            if (confirm("Do you really want to delete?")) {
                let data = { }
                data['User_Id'] = item['_id']
                this.$http.post(`${this.$store.getters.GetProductionUrl}/register/deleteuser`,data)
                            .then(response =>{
                                
                                if(response['data']['Status']){

                                    this.Users      = response['data']['response']
                                    this.AccessTabs = response['data']['All_Tabs']
                                    this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Update User","Color":"green","Close": false });
                                    this.$eventHub.$emit("LOADING",'false')  
                                    this.ClearForm()
                                }else{
                                    this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Couldn't Add User","Color":"red","Close": false });
                                }

                            })
                            .catch(err =>{

                                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                                this.$eventHub.$emit("LOADING",'false')
                            })
            }
        }},
        ClearForm(){

            this.Update_Details = false
            this.Username       = ''
            this.Email          = ''
            this.SelectedTabs   = []
            this.User_Id        = ''

    },
    mounted(){

        this.$http.post(`${this.$store.getters.GetProductionUrl}/register/getaddedusers`)
                        .then(response =>{
                            
                            this.AccessTabs = response['data']['All_Tabs']
                            this.Users      = response['data']['response']
                            this.$eventHub.$emit("LOADING",'false')

                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                            this.$eventHub.$emit("LOADING",'false')
                        })


    }
}
</script>
<style scoped>

</style>
